<template>
  <div>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <header-card
        v-if="!hideHeader"
        :user-avatar="profile"
        title="Your Training Queue"
        sub-title="Manage the training resources that have been sent to you"
      >
        <template v-slot:right>
          <engagement-text
            title="Participation Rate"
            :engagement="outstanding.userRecords"
            class="subtitle-1"
            click
            v-on:click="
              $router.push({ path: `/reporting/participation/training` })
            "
          ></engagement-text>
        </template>
      </header-card>
      <v-row>
        <v-col cols="12" v-for="(item, i) in outstanding.resources" :key="i">
          <v-card>
            <v-row>
              <v-col cols="auto" class="my-auto">
                <v-card-text>
                  <v-btn
                    :href="item.link"
                    target="_blank"
                    color="performance"
                    v-if="item.readDate == null"
                    @click="setReadDate(item)"
                  >
                    View {{ item.typeName }}
                  </v-btn>
                  <v-btn disabled v-else>
                    Viewed
                  </v-btn>
                </v-card-text>
              </v-col>
              <v-col cols="auto">
                <v-card-title>
                  {{ item.title }}
                </v-card-title>
                <v-card-subtitle>
                  Added: {{ item.createdDate | normalDate }} | By:
                  {{ item.author }}
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import EngagementText from "@/components/reporting/EngagementText";
import HeaderCard from "@/components/common/HeaderCard";
export default {
  name: "ResourceQueue",
  props: { hideHeader: { type: Boolean, default: false } },
  components: { EngagementText, HeaderCard },
  data: () => ({ loading: false }),
  computed: {
    ...mapGetters({
      outstanding: "resource/outstanding",
      profile: "profile/profile"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("resource/getOutstandingResources")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your resources."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    setReadDate(item) {
      this.$set(item, "readDate", moment());
    }
  }
};
</script>
